import { paginatedTransform } from 'src/services/skuit/utils'
import { Found, PaginatedResponse } from '../../api/models'

import { API, CustomAxiosConfig } from './types'
import { ExportFilters } from '../skuit/types'
import fileDownload from 'js-file-download'

export interface ExportProps {
  fields: string[],
  exportFilters: ExportFilters,
}

export class FoundAPI {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<Found>> => {
    const response = await this.api.get('/logistics/found', config)
    return paginatedTransform(Found)(response.data)
  }

  export = async ({ fields, exportFilters }: ExportProps) => {
    const guid: string | undefined = exportFilters?.guid
    const params = { fields: fields.join(','), products: guid}
    const response = await this.api.axiosInstance({
      url: 'logistics/found/export',
      params,
      responseType: 'blob'
    })
    fileDownload(response.data, (guid ? `found_product_${guid}.csv` : 'found.csv')) 
  }
}
